var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"elm",class:[
    'CheckVerification',
    ("CheckVerification--" + _vm.interval)
  ]})}
var staticRenderFns = []

export { render, staticRenderFns }